import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PageHeader, Button} from 'scorer-ui-kit';
import { Container, Buttons, BackButton, HeaderContainer, ValidationAlert } from '../../style';

import UploadImage from '../../components/UploadImage';
import { MenuContext, PathContext } from '../../App';
import useLocalStorage from '../../hooks/useLocalstorage';

const InputContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  justify-content: space-between;
  height: 100px;
`;

const AreaInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;

const InputHeader = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #7f7f7f;
  margin-bottom: 7px;
`;

const SmallInputContainer = styled.div`
  display: flex;
  width: auto;
  margin: 0 5px 0 0; 
`;

const InputField = styled.div`
  display: flex;
  flex-direction: column;
`;

const SelectFieldBox = styled.select`
  width: 104px;
  height: 30px;
  padding: 0 0 0 10px;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  color: #767676;
  margin-top: 5px;
  //margin-bottom: 20px;
`;

const SetupJobsManual = () => {
  const { t } = useTranslation(['SetupFloorplan', 'Common']);
  const [validationAlert/*, setValidationAlert*/] = useState<Alert>({ key: new Date(), message: '', type: 'error' });
  
  const { completedStep, setSelectedStep, setCompletedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage, setFloorPlanStorage } = useLocalStorage();
  const [ jobs, setJobs ] = useState(floorPlanStorage.jobs);
  const [ selectedJob, setSelectedJob ] = useState(0);

  const [originalImage, setOriginalImage] = useState(floorPlanStorage.jobs[0].manual_original ? floorPlanStorage.jobs[0].manual_original : '');
  const [croppedImage, setCroppedImage] = useState(floorPlanStorage.jobs[0].manual ? floorPlanStorage.jobs[0].manual : '');

  //今設定中のjobIDを取得
  const getSelectedJob = useCallback((ev) => {
    for(let i=0; i<jobs.length; i++) {
      if(jobs[i].name === ev.target.value) {
        setSelectedJob(i);
        setCroppedImage(jobs[i].manual);
        setOriginalImage(jobs[i].manual_original);
        break;
      }
    }
  }, [jobs]);


  const onCroppedImageChange = useCallback((img_cropped) => {
    const newjobs = [...jobs];
    newjobs[selectedJob].manual = img_cropped;
    setJobs(newjobs);
    setCroppedImage(img_cropped);
    setCompletedStep(1);

  }, [jobs, selectedJob, setCompletedStep ]);

  const onImageChange = useCallback((img_original) => {
    const newjobs = [...jobs];
    newjobs[selectedJob].manual_original = img_original;
    setJobs(newjobs);
    setOriginalImage(img_original);
    onCroppedImageChange(croppedImage);
  }, [jobs, selectedJob, croppedImage, onCroppedImageChange]);

  /*---------route---------*/  
  const onContinue = useCallback((index?: any) => {
    /*if (!image || !croppedImage) {
      setValidationAlert({ key: new Date(), message: t('file_alert'), type: 'error' });
      return;
    }*/
    setFloorPlanStorage({jobs});
    setSelectedStep(index);
    setCompletedStep(completedStep > 14 ? completedStep : 14);
  }, [/*croppedImage, image, t,*/jobs, completedStep, setCompletedStep, setSelectedStep, setFloorPlanStorage]);
  
  useEffect(() => {
    if (pathUpdated) { setSelectedStep(14); }
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='ジョブマニュアル設定' areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <BackButton size='small' design='secondary' onClick={() => onContinue(13)}>{t('Common:back')}</BackButton>
          <Button design='primary' size='small' onClick={() => onContinue(15)}>{t('Common:next')}</Button>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}
        
      <InputContainer>
        <AreaInfo>
          <InputHeader>編集するジョブを選択</InputHeader>
          <SmallInputContainer>
            <InputField>
              <SelectFieldBox value={jobs[selectedJob].name} onChange={getSelectedJob}>
                {jobs.map((job: any)=>{
                  return <option key={'select_job_'+job.id} value={job.name}>{job.name}</option>;
                })}
              </SelectFieldBox>
            </InputField>
          </SmallInputContainer>
        </AreaInfo>
      </InputContainer>

      <UploadImage image={originalImage} croppedImage={croppedImage} onImageChange={onImageChange} onCroppedImageChange={onCroppedImageChange} />
    </Container>
  );
};


export default SetupJobsManual;
